export default  {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: require('../views/pageContent.confirmation.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.confirmation.component.js